import { Box, Modal, SxProps, TextField } from '@mui/material';
import { createContext, useContext, useState, useEffect, PropsWithChildren, ReactElement } from 'react';
import { ActionButton } from '..';
import { Theme } from '@emotion/react';

type HandleClose = (_?: object, reason?: 'backdropClick' | 'escapeKeyDown') => void;

//TODO: Para tipar JuaniBellavitis
interface ModalStore {
  ModalStatus: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  HandleClose: HandleClose;
}

interface ModalProps {
  children: ReactElement | ReactElement[];
  open: boolean;
  ModalIsOpen: (value: boolean) => void;
  width?: string;
  backdropOff?: boolean;
}

export const ModalContext = createContext<ModalStore | undefined>(undefined);

export function ModalIOF({ children, open, ModalIsOpen, width, backdropOff }: ModalProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleClose = (_?: object, reason?: 'backdropClick' | 'escapeKeyDown') => {
    const backdropCase = reason === 'backdropClick' || reason === 'escapeKeyDown';
    if (backdropCase && backdropOff) return;
    setIsOpen(false);
    ModalIsOpen(false);
  };

  const store: ModalStore = {
    ModalStatus: [isOpen, setIsOpen],
    HandleClose: handleClose,
  };

  const style = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: width ? width : '50%',
    height: 'auto',
    bgcolor: 'background.paper',
    borderRadius: '10px',
    boxShadow: 'none',
    padding: '20px',
    maxHeight: '90vh',
    overflowY: 'auto',
    outline: 'none',
  };

  return (
    <ModalContext.Provider value={store}>
      <Modal open={isOpen} onClose={handleClose}>
        <Box sx={{ ...style }}>{children}</Box>
      </Modal>
    </ModalContext.Provider>
  );
}

function Header({ children }: PropsWithChildren) {
  return (
    <Box
      style={{ display: 'flex', justifyContent: 'space-between' }}
      // sx={{ borderColor: 'divider', borderBottom: 1 }}
    >
      {children}
    </Box>
  );
}

function HeaderCenter({ children }: PropsWithChildren) {
  return (
    <Box
      style={{ display: 'flex', justifyContent: 'center' }}
      // sx={{ borderColor: 'divider', borderBottom: 1 }}
    >
      {children}
    </Box>
  );
}

function Title({ children }: PropsWithChildren) {
  return <h2>{children}</h2>;
}

function Helper({ children }: PropsWithChildren) {
  return (
    <div
      style={{
        width: '25%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
      }}
    >
      {children}
    </div>
  );
}

function Input({ children }: { children: ReactElement }) {
  return <TextField label={children} />;
}

// 'type CustomButtonProps' duplicated on action-button.tsx
type CustomButtonProps = {
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'inherit' | 'success' | 'primary' | 'secondary' | 'error' | 'info' | 'warning';
  text?: string;
  size?: 'small' | 'medium' | 'large';
  onClick?: () => void;
  sx?: SxProps<Theme>;
};
type ButtonProps = {
  close: boolean;
  save?: boolean;
  onClick: () => void;
};
function Button({
  children,
  close,
  save,
  onClick,
  ...props
}: PropsWithChildren<ButtonProps> & CustomButtonProps) {
  const modalContext = useContext(ModalContext);
  const handleClose = modalContext?.HandleClose;

  const saveButton = () => onClick && onClick();

  const closeModal = () => handleClose && handleClose();

  const handleClick = () => {
    if (close) closeModal();
    if (save) saveButton();
  };

  return <ActionButton onClick={handleClick} text={children as string} {...props} />;
}

function Body({ children }: PropsWithChildren) {
  return <div>{children}</div>;
}

ModalIOF.Header = Header;
ModalIOF.HeaderCenter = HeaderCenter;
ModalIOF.Input = Input;
ModalIOF.Helper = Helper;
ModalIOF.Title = Title;
ModalIOF.Button = Button;
ModalIOF.Body = Body;
